// packages/alpinejs/src/scheduler.js
var $9639c662cd69943f$var$flushPending = false;
var $9639c662cd69943f$var$flushing = false;
var $9639c662cd69943f$var$queue = [];
var $9639c662cd69943f$var$lastFlushedIndex = -1;
var $9639c662cd69943f$var$transactionActive = false;
function $9639c662cd69943f$var$scheduler(callback) {
    $9639c662cd69943f$var$queueJob(callback);
}
function $9639c662cd69943f$var$startTransaction() {
    $9639c662cd69943f$var$transactionActive = true;
}
function $9639c662cd69943f$var$commitTransaction() {
    $9639c662cd69943f$var$transactionActive = false;
    $9639c662cd69943f$var$queueFlush();
}
function $9639c662cd69943f$var$queueJob(job) {
    if (!$9639c662cd69943f$var$queue.includes(job)) $9639c662cd69943f$var$queue.push(job);
    $9639c662cd69943f$var$queueFlush();
}
function $9639c662cd69943f$var$dequeueJob(job) {
    let index = $9639c662cd69943f$var$queue.indexOf(job);
    if (index !== -1 && index > $9639c662cd69943f$var$lastFlushedIndex) $9639c662cd69943f$var$queue.splice(index, 1);
}
function $9639c662cd69943f$var$queueFlush() {
    if (!$9639c662cd69943f$var$flushing && !$9639c662cd69943f$var$flushPending) {
        if ($9639c662cd69943f$var$transactionActive) return;
        $9639c662cd69943f$var$flushPending = true;
        queueMicrotask($9639c662cd69943f$var$flushJobs);
    }
}
function $9639c662cd69943f$var$flushJobs() {
    $9639c662cd69943f$var$flushPending = false;
    $9639c662cd69943f$var$flushing = true;
    for(let i = 0; i < $9639c662cd69943f$var$queue.length; i++){
        $9639c662cd69943f$var$queue[i]();
        $9639c662cd69943f$var$lastFlushedIndex = i;
    }
    $9639c662cd69943f$var$queue.length = 0;
    $9639c662cd69943f$var$lastFlushedIndex = -1;
    $9639c662cd69943f$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $9639c662cd69943f$var$reactive;
var $9639c662cd69943f$var$effect;
var $9639c662cd69943f$var$release;
var $9639c662cd69943f$var$raw;
var $9639c662cd69943f$var$shouldSchedule = true;
function $9639c662cd69943f$var$disableEffectScheduling(callback) {
    $9639c662cd69943f$var$shouldSchedule = false;
    callback();
    $9639c662cd69943f$var$shouldSchedule = true;
}
function $9639c662cd69943f$var$setReactivityEngine(engine) {
    $9639c662cd69943f$var$reactive = engine.reactive;
    $9639c662cd69943f$var$release = engine.release;
    $9639c662cd69943f$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($9639c662cd69943f$var$shouldSchedule) $9639c662cd69943f$var$scheduler(task);
                else task();
            }
        });
    $9639c662cd69943f$var$raw = engine.raw;
}
function $9639c662cd69943f$var$overrideEffect(override) {
    $9639c662cd69943f$var$effect = override;
}
function $9639c662cd69943f$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $9639c662cd69943f$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $9639c662cd69943f$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $9639c662cd69943f$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $9639c662cd69943f$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$9639c662cd69943f$var$release(effectReference);
}
async function $9639c662cd69943f$var$transaction(callback) {
    $9639c662cd69943f$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $9639c662cd69943f$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $9639c662cd69943f$var$onAttributeAddeds = [];
var $9639c662cd69943f$var$onElRemoveds = [];
var $9639c662cd69943f$var$onElAddeds = [];
function $9639c662cd69943f$var$onElAdded(callback) {
    $9639c662cd69943f$var$onElAddeds.push(callback);
}
function $9639c662cd69943f$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $9639c662cd69943f$var$onElRemoveds.push(callback);
    }
}
function $9639c662cd69943f$var$onAttributesAdded(callback) {
    $9639c662cd69943f$var$onAttributeAddeds.push(callback);
}
function $9639c662cd69943f$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $9639c662cd69943f$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $9639c662cd69943f$var$cleanupElement(el) {
    el._x_effects?.forEach($9639c662cd69943f$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $9639c662cd69943f$var$observer = new MutationObserver($9639c662cd69943f$var$onMutate);
var $9639c662cd69943f$var$currentlyObserving = false;
function $9639c662cd69943f$var$startObservingMutations() {
    $9639c662cd69943f$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $9639c662cd69943f$var$currentlyObserving = true;
}
function $9639c662cd69943f$var$stopObservingMutations() {
    $9639c662cd69943f$var$flushObserver();
    $9639c662cd69943f$var$observer.disconnect();
    $9639c662cd69943f$var$currentlyObserving = false;
}
var $9639c662cd69943f$var$queuedMutations = [];
function $9639c662cd69943f$var$flushObserver() {
    let records = $9639c662cd69943f$var$observer.takeRecords();
    $9639c662cd69943f$var$queuedMutations.push(()=>records.length > 0 && $9639c662cd69943f$var$onMutate(records));
    let queueLengthWhenTriggered = $9639c662cd69943f$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($9639c662cd69943f$var$queuedMutations.length === queueLengthWhenTriggered) while($9639c662cd69943f$var$queuedMutations.length > 0)$9639c662cd69943f$var$queuedMutations.shift()();
    });
}
function $9639c662cd69943f$var$mutateDom(callback) {
    if (!$9639c662cd69943f$var$currentlyObserving) return callback();
    $9639c662cd69943f$var$stopObservingMutations();
    let result = callback();
    $9639c662cd69943f$var$startObservingMutations();
    return result;
}
var $9639c662cd69943f$var$isCollecting = false;
var $9639c662cd69943f$var$deferredMutations = [];
function $9639c662cd69943f$var$deferMutations() {
    $9639c662cd69943f$var$isCollecting = true;
}
function $9639c662cd69943f$var$flushAndStopDeferringMutations() {
    $9639c662cd69943f$var$isCollecting = false;
    $9639c662cd69943f$var$onMutate($9639c662cd69943f$var$deferredMutations);
    $9639c662cd69943f$var$deferredMutations = [];
}
function $9639c662cd69943f$var$onMutate(mutations) {
    if ($9639c662cd69943f$var$isCollecting) {
        $9639c662cd69943f$var$deferredMutations = $9639c662cd69943f$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $9639c662cd69943f$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $9639c662cd69943f$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $9639c662cd69943f$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $9639c662cd69943f$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $9639c662cd69943f$var$scope(node) {
    return $9639c662cd69943f$var$mergeProxies($9639c662cd69943f$var$closestDataStack(node));
}
function $9639c662cd69943f$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$9639c662cd69943f$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $9639c662cd69943f$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $9639c662cd69943f$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $9639c662cd69943f$var$closestDataStack(node.parentNode);
}
function $9639c662cd69943f$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $9639c662cd69943f$var$mergeProxyTrap);
}
var $9639c662cd69943f$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $9639c662cd69943f$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $9639c662cd69943f$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $9639c662cd69943f$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $9639c662cd69943f$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$9639c662cd69943f$var$get(data2, path), (value)=>$9639c662cd69943f$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $9639c662cd69943f$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $9639c662cd69943f$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $9639c662cd69943f$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $9639c662cd69943f$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $9639c662cd69943f$var$magics = {};
function $9639c662cd69943f$var$magic(name, callback) {
    $9639c662cd69943f$var$magics[name] = callback;
}
function $9639c662cd69943f$var$injectMagics(obj, el) {
    let memoizedUtilities = $9639c662cd69943f$var$getUtilities(el);
    Object.entries($9639c662cd69943f$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $9639c662cd69943f$var$getUtilities(el) {
    let [utilities, cleanup2] = $9639c662cd69943f$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $9639c662cd69943f$var$interceptor,
        ...utilities
    };
    $9639c662cd69943f$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $9639c662cd69943f$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $9639c662cd69943f$var$handleError(e, el, expression);
    }
}
function $9639c662cd69943f$var$handleError(...args) {
    return $9639c662cd69943f$var$errorHandler(...args);
}
var $9639c662cd69943f$var$errorHandler = $9639c662cd69943f$var$normalErrorHandler;
function $9639c662cd69943f$var$setErrorHandler(handler4) {
    $9639c662cd69943f$var$errorHandler = handler4;
}
function $9639c662cd69943f$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $9639c662cd69943f$var$shouldAutoEvaluateFunctions = true;
function $9639c662cd69943f$var$dontAutoEvaluateFunctions(callback) {
    let cache = $9639c662cd69943f$var$shouldAutoEvaluateFunctions;
    $9639c662cd69943f$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $9639c662cd69943f$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $9639c662cd69943f$var$evaluate(el, expression, extras = {}) {
    let result;
    $9639c662cd69943f$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $9639c662cd69943f$var$evaluateLater(...args) {
    return $9639c662cd69943f$var$theEvaluatorFunction(...args);
}
var $9639c662cd69943f$var$theEvaluatorFunction = $9639c662cd69943f$var$normalEvaluator;
function $9639c662cd69943f$var$setEvaluator(newEvaluator) {
    $9639c662cd69943f$var$theEvaluatorFunction = newEvaluator;
}
var $9639c662cd69943f$var$theRawEvaluatorFunction;
function $9639c662cd69943f$var$setRawEvaluator(newEvaluator) {
    $9639c662cd69943f$var$theRawEvaluatorFunction = newEvaluator;
}
function $9639c662cd69943f$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $9639c662cd69943f$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$9639c662cd69943f$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $9639c662cd69943f$var$generateEvaluatorFromFunction(dataStack, expression) : $9639c662cd69943f$var$generateEvaluatorFromString(dataStack, expression, el);
    return $9639c662cd69943f$var$tryCatch.bind(null, el, expression, evaluator);
}
function $9639c662cd69943f$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$9639c662cd69943f$var$shouldAutoEvaluateFunctions) {
            $9639c662cd69943f$var$runIfTypeOfFunction(receiver, func, $9639c662cd69943f$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($9639c662cd69943f$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $9639c662cd69943f$var$runIfTypeOfFunction(receiver, result);
    };
}
var $9639c662cd69943f$var$evaluatorMemo = {};
function $9639c662cd69943f$var$generateFunctionFromString(expression, el) {
    if ($9639c662cd69943f$var$evaluatorMemo[expression]) return $9639c662cd69943f$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $9639c662cd69943f$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $9639c662cd69943f$var$evaluatorMemo[expression] = func;
    return func;
}
function $9639c662cd69943f$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $9639c662cd69943f$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $9639c662cd69943f$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$9639c662cd69943f$var$handleError(error2, el, expression));
            if (func.finished) {
                $9639c662cd69943f$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $9639c662cd69943f$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$9639c662cd69943f$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $9639c662cd69943f$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($9639c662cd69943f$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$9639c662cd69943f$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$9639c662cd69943f$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $9639c662cd69943f$var$evaluateRaw(...args) {
    return $9639c662cd69943f$var$theRawEvaluatorFunction(...args);
}
function $9639c662cd69943f$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $9639c662cd69943f$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$9639c662cd69943f$var$closestDataStack(el)
    ];
    let scope2 = $9639c662cd69943f$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $9639c662cd69943f$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $9639c662cd69943f$var$prefixAsString = "x-";
function $9639c662cd69943f$var$prefix(subject = "") {
    return $9639c662cd69943f$var$prefixAsString + subject;
}
function $9639c662cd69943f$var$setPrefix(newPrefix) {
    $9639c662cd69943f$var$prefixAsString = newPrefix;
}
var $9639c662cd69943f$var$directiveHandlers = {};
function $9639c662cd69943f$var$directive(name, callback) {
    $9639c662cd69943f$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$9639c662cd69943f$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $9639c662cd69943f$var$directiveOrder.indexOf(directive2);
            $9639c662cd69943f$var$directiveOrder.splice(pos >= 0 ? pos : $9639c662cd69943f$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $9639c662cd69943f$var$directiveExists(name) {
    return Object.keys($9639c662cd69943f$var$directiveHandlers).includes(name);
}
function $9639c662cd69943f$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $9639c662cd69943f$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($9639c662cd69943f$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($9639c662cd69943f$var$outNonAlpineAttributes).map($9639c662cd69943f$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($9639c662cd69943f$var$byPriority);
    return directives2.map((directive2)=>{
        return $9639c662cd69943f$var$getDirectiveHandler(el, directive2);
    });
}
function $9639c662cd69943f$var$attributesOnly(attributes) {
    return Array.from(attributes).map($9639c662cd69943f$var$toTransformedAttributes()).filter((attr)=>!$9639c662cd69943f$var$outNonAlpineAttributes(attr));
}
var $9639c662cd69943f$var$isDeferringHandlers = false;
var $9639c662cd69943f$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $9639c662cd69943f$var$currentHandlerStackKey = Symbol();
function $9639c662cd69943f$var$deferHandlingDirectives(callback) {
    $9639c662cd69943f$var$isDeferringHandlers = true;
    let key = Symbol();
    $9639c662cd69943f$var$currentHandlerStackKey = key;
    $9639c662cd69943f$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($9639c662cd69943f$var$directiveHandlerStacks.get(key).length)$9639c662cd69943f$var$directiveHandlerStacks.get(key).shift()();
        $9639c662cd69943f$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $9639c662cd69943f$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $9639c662cd69943f$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $9639c662cd69943f$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $9639c662cd69943f$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $9639c662cd69943f$var$evaluateLater.bind($9639c662cd69943f$var$evaluateLater, el),
        evaluate: $9639c662cd69943f$var$evaluate.bind($9639c662cd69943f$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $9639c662cd69943f$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $9639c662cd69943f$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $9639c662cd69943f$var$getElementBoundUtilities(el);
    $9639c662cd69943f$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $9639c662cd69943f$var$isDeferringHandlers ? $9639c662cd69943f$var$directiveHandlerStacks.get($9639c662cd69943f$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $9639c662cd69943f$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $9639c662cd69943f$var$into = (i)=>i;
function $9639c662cd69943f$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $9639c662cd69943f$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $9639c662cd69943f$var$attributeTransformers = [];
function $9639c662cd69943f$var$mapAttributes(callback) {
    $9639c662cd69943f$var$attributeTransformers.push(callback);
}
function $9639c662cd69943f$var$outNonAlpineAttributes({ name: name }) {
    return $9639c662cd69943f$var$alpineAttributeRegex().test(name);
}
var $9639c662cd69943f$var$alpineAttributeRegex = ()=>new RegExp(`^${$9639c662cd69943f$var$prefixAsString}([^:^.]+)\\b`);
function $9639c662cd69943f$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($9639c662cd69943f$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $9639c662cd69943f$var$DEFAULT = "DEFAULT";
var $9639c662cd69943f$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $9639c662cd69943f$var$DEFAULT,
    "teleport"
];
function $9639c662cd69943f$var$byPriority(a, b) {
    let typeA = $9639c662cd69943f$var$directiveOrder.indexOf(a.type) === -1 ? $9639c662cd69943f$var$DEFAULT : a.type;
    let typeB = $9639c662cd69943f$var$directiveOrder.indexOf(b.type) === -1 ? $9639c662cd69943f$var$DEFAULT : b.type;
    return $9639c662cd69943f$var$directiveOrder.indexOf(typeA) - $9639c662cd69943f$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $9639c662cd69943f$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $9639c662cd69943f$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$9639c662cd69943f$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $9639c662cd69943f$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $9639c662cd69943f$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $9639c662cd69943f$var$started = false;
function $9639c662cd69943f$var$start() {
    if ($9639c662cd69943f$var$started) $9639c662cd69943f$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $9639c662cd69943f$var$started = true;
    if (!document.body) $9639c662cd69943f$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $9639c662cd69943f$var$dispatch(document, "alpine:init");
    $9639c662cd69943f$var$dispatch(document, "alpine:initializing");
    $9639c662cd69943f$var$startObservingMutations();
    $9639c662cd69943f$var$onElAdded((el)=>$9639c662cd69943f$var$initTree(el, $9639c662cd69943f$var$walk));
    $9639c662cd69943f$var$onElRemoved((el)=>$9639c662cd69943f$var$destroyTree(el));
    $9639c662cd69943f$var$onAttributesAdded((el, attrs)=>{
        $9639c662cd69943f$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$9639c662cd69943f$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($9639c662cd69943f$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $9639c662cd69943f$var$initTree(el);
    });
    $9639c662cd69943f$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $9639c662cd69943f$var$warnAboutMissingPlugins();
    });
}
var $9639c662cd69943f$var$rootSelectorCallbacks = [];
var $9639c662cd69943f$var$initSelectorCallbacks = [];
function $9639c662cd69943f$var$rootSelectors() {
    return $9639c662cd69943f$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $9639c662cd69943f$var$allSelectors() {
    return $9639c662cd69943f$var$rootSelectorCallbacks.concat($9639c662cd69943f$var$initSelectorCallbacks).map((fn)=>fn());
}
function $9639c662cd69943f$var$addRootSelector(selectorCallback) {
    $9639c662cd69943f$var$rootSelectorCallbacks.push(selectorCallback);
}
function $9639c662cd69943f$var$addInitSelector(selectorCallback) {
    $9639c662cd69943f$var$initSelectorCallbacks.push(selectorCallback);
}
function $9639c662cd69943f$var$closestRoot(el, includeInitSelectors = false) {
    return $9639c662cd69943f$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $9639c662cd69943f$var$allSelectors() : $9639c662cd69943f$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $9639c662cd69943f$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $9639c662cd69943f$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $9639c662cd69943f$var$findClosest(el.parentElement, callback);
}
function $9639c662cd69943f$var$isRoot(el) {
    return $9639c662cd69943f$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $9639c662cd69943f$var$initInterceptors2 = [];
function $9639c662cd69943f$var$interceptInit(callback) {
    $9639c662cd69943f$var$initInterceptors2.push(callback);
}
var $9639c662cd69943f$var$markerDispenser = 1;
function $9639c662cd69943f$var$initTree(el, walker = $9639c662cd69943f$var$walk, intercept = ()=>{}) {
    if ($9639c662cd69943f$var$findClosest(el, (i)=>i._x_ignore)) return;
    $9639c662cd69943f$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $9639c662cd69943f$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $9639c662cd69943f$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $9639c662cd69943f$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $9639c662cd69943f$var$destroyTree(root, walker = $9639c662cd69943f$var$walk) {
    walker(root, (el)=>{
        $9639c662cd69943f$var$cleanupElement(el);
        $9639c662cd69943f$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $9639c662cd69943f$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($9639c662cd69943f$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $9639c662cd69943f$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $9639c662cd69943f$var$tickStack = [];
var $9639c662cd69943f$var$isHolding = false;
function $9639c662cd69943f$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $9639c662cd69943f$var$isHolding || setTimeout(()=>{
            $9639c662cd69943f$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $9639c662cd69943f$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $9639c662cd69943f$var$releaseNextTicks() {
    $9639c662cd69943f$var$isHolding = false;
    while($9639c662cd69943f$var$tickStack.length)$9639c662cd69943f$var$tickStack.shift()();
}
function $9639c662cd69943f$var$holdNextTicks() {
    $9639c662cd69943f$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $9639c662cd69943f$var$setClasses(el, value) {
    if (Array.isArray(value)) return $9639c662cd69943f$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $9639c662cd69943f$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $9639c662cd69943f$var$setClasses(el, value());
    return $9639c662cd69943f$var$setClassesFromString(el, value);
}
function $9639c662cd69943f$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $9639c662cd69943f$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $9639c662cd69943f$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $9639c662cd69943f$var$setStylesFromObject(el, value);
    return $9639c662cd69943f$var$setStylesFromString(el, value);
}
function $9639c662cd69943f$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $9639c662cd69943f$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $9639c662cd69943f$var$setStyles(el, previousStyles);
    };
}
function $9639c662cd69943f$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $9639c662cd69943f$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $9639c662cd69943f$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$9639c662cd69943f$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $9639c662cd69943f$var$registerTransitionsFromHelper(el, modifiers, value);
    else $9639c662cd69943f$var$registerTransitionsFromClassString(el, expression, value);
});
function $9639c662cd69943f$var$registerTransitionsFromClassString(el, classString, stage) {
    $9639c662cd69943f$var$registerTransitionObject(el, $9639c662cd69943f$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $9639c662cd69943f$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $9639c662cd69943f$var$registerTransitionObject(el, $9639c662cd69943f$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $9639c662cd69943f$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $9639c662cd69943f$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $9639c662cd69943f$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $9639c662cd69943f$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $9639c662cd69943f$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $9639c662cd69943f$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $9639c662cd69943f$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $9639c662cd69943f$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $9639c662cd69943f$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $9639c662cd69943f$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $9639c662cd69943f$var$closestHide(parent);
}
function $9639c662cd69943f$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $9639c662cd69943f$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $9639c662cd69943f$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $9639c662cd69943f$var$once(()=>{
        $9639c662cd69943f$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $9639c662cd69943f$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $9639c662cd69943f$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $9639c662cd69943f$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $9639c662cd69943f$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $9639c662cd69943f$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $9639c662cd69943f$var$mutateDom(()=>{
                stages.end();
            });
            $9639c662cd69943f$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $9639c662cd69943f$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $9639c662cd69943f$var$isCloning = false;
function $9639c662cd69943f$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$9639c662cd69943f$var$isCloning ? fallback(...args) : callback(...args);
}
function $9639c662cd69943f$var$onlyDuringClone(callback) {
    return (...args)=>$9639c662cd69943f$var$isCloning && callback(...args);
}
var $9639c662cd69943f$var$interceptors = [];
function $9639c662cd69943f$var$interceptClone(callback) {
    $9639c662cd69943f$var$interceptors.push(callback);
}
function $9639c662cd69943f$var$cloneNode(from, to) {
    $9639c662cd69943f$var$interceptors.forEach((i)=>i(from, to));
    $9639c662cd69943f$var$isCloning = true;
    $9639c662cd69943f$var$dontRegisterReactiveSideEffects(()=>{
        $9639c662cd69943f$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $9639c662cd69943f$var$isCloning = false;
}
var $9639c662cd69943f$var$isCloningLegacy = false;
function $9639c662cd69943f$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $9639c662cd69943f$var$isCloning = true;
    $9639c662cd69943f$var$isCloningLegacy = true;
    $9639c662cd69943f$var$dontRegisterReactiveSideEffects(()=>{
        $9639c662cd69943f$var$cloneTree(newEl);
    });
    $9639c662cd69943f$var$isCloning = false;
    $9639c662cd69943f$var$isCloningLegacy = false;
}
function $9639c662cd69943f$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $9639c662cd69943f$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $9639c662cd69943f$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $9639c662cd69943f$var$initTree(el, shallowWalker);
}
function $9639c662cd69943f$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $9639c662cd69943f$var$effect;
    $9639c662cd69943f$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $9639c662cd69943f$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $9639c662cd69943f$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $9639c662cd69943f$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $9639c662cd69943f$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $9639c662cd69943f$var$camelCase(name) : name;
    switch(name){
        case "value":
            $9639c662cd69943f$var$bindInputValue(el, value);
            break;
        case "style":
            $9639c662cd69943f$var$bindStyles(el, value);
            break;
        case "class":
            $9639c662cd69943f$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $9639c662cd69943f$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $9639c662cd69943f$var$bindAttribute(el, name, value);
            break;
    }
}
function $9639c662cd69943f$var$bindInputValue(el, value) {
    if ($9639c662cd69943f$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $9639c662cd69943f$var$safeParseBoolean(el.value) === value;
            else el.checked = $9639c662cd69943f$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($9639c662cd69943f$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$9639c662cd69943f$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $9639c662cd69943f$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $9639c662cd69943f$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $9639c662cd69943f$var$setClasses(el, value);
}
function $9639c662cd69943f$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $9639c662cd69943f$var$setStyles(el, value);
}
function $9639c662cd69943f$var$bindAttributeAndProperty(el, name, value) {
    $9639c662cd69943f$var$bindAttribute(el, name, value);
    $9639c662cd69943f$var$setPropertyIfChanged(el, name, value);
}
function $9639c662cd69943f$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $9639c662cd69943f$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($9639c662cd69943f$var$isBooleanAttr(name)) value = name;
        $9639c662cd69943f$var$setIfChanged(el, name, value);
    }
}
function $9639c662cd69943f$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $9639c662cd69943f$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $9639c662cd69943f$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $9639c662cd69943f$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $9639c662cd69943f$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $9639c662cd69943f$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $9639c662cd69943f$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $9639c662cd69943f$var$isBooleanAttr(attrName) {
    return $9639c662cd69943f$var$booleanAttributes.has(attrName);
}
function $9639c662cd69943f$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $9639c662cd69943f$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $9639c662cd69943f$var$getAttributeBinding(el, name, fallback);
}
function $9639c662cd69943f$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $9639c662cd69943f$var$dontAutoEvaluateFunctions(()=>{
            return $9639c662cd69943f$var$evaluate(el, binding.expression);
        });
    }
    return $9639c662cd69943f$var$getAttributeBinding(el, name, fallback);
}
function $9639c662cd69943f$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($9639c662cd69943f$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $9639c662cd69943f$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $9639c662cd69943f$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $9639c662cd69943f$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $9639c662cd69943f$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $9639c662cd69943f$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $9639c662cd69943f$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($9639c662cd69943f$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($9639c662cd69943f$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($9639c662cd69943f$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $9639c662cd69943f$var$release(reference);
    };
}
function $9639c662cd69943f$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $9639c662cd69943f$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($9639c662cd69943f$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $9639c662cd69943f$var$stores = {};
var $9639c662cd69943f$var$isReactive = false;
function $9639c662cd69943f$var$store(name, value) {
    if (!$9639c662cd69943f$var$isReactive) {
        $9639c662cd69943f$var$stores = $9639c662cd69943f$var$reactive($9639c662cd69943f$var$stores);
        $9639c662cd69943f$var$isReactive = true;
    }
    if (value === void 0) return $9639c662cd69943f$var$stores[name];
    $9639c662cd69943f$var$stores[name] = value;
    $9639c662cd69943f$var$initInterceptors($9639c662cd69943f$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $9639c662cd69943f$var$stores[name].init();
}
function $9639c662cd69943f$var$getStores() {
    return $9639c662cd69943f$var$stores;
}
// packages/alpinejs/src/binds.js
var $9639c662cd69943f$var$binds = {};
function $9639c662cd69943f$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $9639c662cd69943f$var$applyBindingsObject(name, getBindings());
    else $9639c662cd69943f$var$binds[name] = getBindings;
    return ()=>{};
}
function $9639c662cd69943f$var$injectBindingProviders(obj) {
    Object.entries($9639c662cd69943f$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $9639c662cd69943f$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $9639c662cd69943f$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $9639c662cd69943f$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $9639c662cd69943f$var$datas = {};
function $9639c662cd69943f$var$data(name, callback) {
    $9639c662cd69943f$var$datas[name] = callback;
}
function $9639c662cd69943f$var$injectDataProviders(obj, context) {
    Object.entries($9639c662cd69943f$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $9639c662cd69943f$var$Alpine = {
    get reactive () {
        return $9639c662cd69943f$var$reactive;
    },
    get release () {
        return $9639c662cd69943f$var$release;
    },
    get effect () {
        return $9639c662cd69943f$var$effect;
    },
    get raw () {
        return $9639c662cd69943f$var$raw;
    },
    get transaction () {
        return $9639c662cd69943f$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $9639c662cd69943f$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $9639c662cd69943f$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $9639c662cd69943f$var$disableEffectScheduling,
    startObservingMutations: $9639c662cd69943f$var$startObservingMutations,
    stopObservingMutations: $9639c662cd69943f$var$stopObservingMutations,
    setReactivityEngine: $9639c662cd69943f$var$setReactivityEngine,
    onAttributeRemoved: $9639c662cd69943f$var$onAttributeRemoved,
    onAttributesAdded: $9639c662cd69943f$var$onAttributesAdded,
    closestDataStack: $9639c662cd69943f$var$closestDataStack,
    skipDuringClone: $9639c662cd69943f$var$skipDuringClone,
    onlyDuringClone: $9639c662cd69943f$var$onlyDuringClone,
    addRootSelector: $9639c662cd69943f$var$addRootSelector,
    addInitSelector: $9639c662cd69943f$var$addInitSelector,
    setErrorHandler: $9639c662cd69943f$var$setErrorHandler,
    interceptClone: $9639c662cd69943f$var$interceptClone,
    addScopeToNode: $9639c662cd69943f$var$addScopeToNode,
    deferMutations: $9639c662cd69943f$var$deferMutations,
    mapAttributes: $9639c662cd69943f$var$mapAttributes,
    evaluateLater: $9639c662cd69943f$var$evaluateLater,
    interceptInit: $9639c662cd69943f$var$interceptInit,
    initInterceptors: $9639c662cd69943f$var$initInterceptors,
    injectMagics: $9639c662cd69943f$var$injectMagics,
    setEvaluator: $9639c662cd69943f$var$setEvaluator,
    setRawEvaluator: $9639c662cd69943f$var$setRawEvaluator,
    mergeProxies: $9639c662cd69943f$var$mergeProxies,
    extractProp: $9639c662cd69943f$var$extractProp,
    findClosest: $9639c662cd69943f$var$findClosest,
    onElRemoved: $9639c662cd69943f$var$onElRemoved,
    closestRoot: $9639c662cd69943f$var$closestRoot,
    destroyTree: $9639c662cd69943f$var$destroyTree,
    interceptor: $9639c662cd69943f$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $9639c662cd69943f$var$transition,
    setStyles: // INTERNAL
    $9639c662cd69943f$var$setStyles,
    mutateDom: // INTERNAL
    $9639c662cd69943f$var$mutateDom,
    directive: $9639c662cd69943f$var$directive,
    entangle: $9639c662cd69943f$var$entangle,
    throttle: $9639c662cd69943f$var$throttle,
    debounce: $9639c662cd69943f$var$debounce,
    evaluate: $9639c662cd69943f$var$evaluate,
    evaluateRaw: $9639c662cd69943f$var$evaluateRaw,
    initTree: $9639c662cd69943f$var$initTree,
    nextTick: $9639c662cd69943f$var$nextTick,
    prefixed: $9639c662cd69943f$var$prefix,
    prefix: $9639c662cd69943f$var$setPrefix,
    plugin: $9639c662cd69943f$var$plugin,
    magic: $9639c662cd69943f$var$magic,
    store: $9639c662cd69943f$var$store,
    start: $9639c662cd69943f$var$start,
    clone: $9639c662cd69943f$var$clone,
    cloneNode: // INTERNAL
    $9639c662cd69943f$var$cloneNode,
    // INTERNAL
    bound: $9639c662cd69943f$var$getBinding,
    $data: $9639c662cd69943f$var$scope,
    watch: $9639c662cd69943f$var$watch,
    walk: $9639c662cd69943f$var$walk,
    data: $9639c662cd69943f$var$data,
    bind: $9639c662cd69943f$var$bind2
};
var $9639c662cd69943f$var$alpine_default = $9639c662cd69943f$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $9639c662cd69943f$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $9639c662cd69943f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $9639c662cd69943f$var$isBooleanAttr2 = /* @__PURE__ */ $9639c662cd69943f$var$makeMap($9639c662cd69943f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $9639c662cd69943f$var$EMPTY_OBJ = Object.freeze({});
var $9639c662cd69943f$var$EMPTY_ARR = Object.freeze([]);
var $9639c662cd69943f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $9639c662cd69943f$var$hasOwn = (val, key)=>$9639c662cd69943f$var$hasOwnProperty.call(val, key);
var $9639c662cd69943f$var$isArray = Array.isArray;
var $9639c662cd69943f$var$isMap = (val)=>$9639c662cd69943f$var$toTypeString(val) === "[object Map]";
var $9639c662cd69943f$var$isString = (val)=>typeof val === "string";
var $9639c662cd69943f$var$isSymbol = (val)=>typeof val === "symbol";
var $9639c662cd69943f$var$isObject = (val)=>val !== null && typeof val === "object";
var $9639c662cd69943f$var$objectToString = Object.prototype.toString;
var $9639c662cd69943f$var$toTypeString = (value)=>$9639c662cd69943f$var$objectToString.call(value);
var $9639c662cd69943f$var$toRawType = (value)=>{
    return $9639c662cd69943f$var$toTypeString(value).slice(8, -1);
};
var $9639c662cd69943f$var$isIntegerKey = (key)=>$9639c662cd69943f$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $9639c662cd69943f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $9639c662cd69943f$var$camelizeRE = /-(\w)/g;
var $9639c662cd69943f$var$camelize = $9639c662cd69943f$var$cacheStringFunction((str)=>{
    return str.replace($9639c662cd69943f$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $9639c662cd69943f$var$hyphenateRE = /\B([A-Z])/g;
var $9639c662cd69943f$var$hyphenate = $9639c662cd69943f$var$cacheStringFunction((str)=>str.replace($9639c662cd69943f$var$hyphenateRE, "-$1").toLowerCase());
var $9639c662cd69943f$var$capitalize = $9639c662cd69943f$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $9639c662cd69943f$var$toHandlerKey = $9639c662cd69943f$var$cacheStringFunction((str)=>str ? `on${$9639c662cd69943f$var$capitalize(str)}` : ``);
var $9639c662cd69943f$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $9639c662cd69943f$var$targetMap = /* @__PURE__ */ new WeakMap();
var $9639c662cd69943f$var$effectStack = [];
var $9639c662cd69943f$var$activeEffect;
var $9639c662cd69943f$var$ITERATE_KEY = Symbol("iterate");
var $9639c662cd69943f$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $9639c662cd69943f$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $9639c662cd69943f$var$effect2(fn, options = $9639c662cd69943f$var$EMPTY_OBJ) {
    if ($9639c662cd69943f$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $9639c662cd69943f$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $9639c662cd69943f$var$stop(effect3) {
    if (effect3.active) {
        $9639c662cd69943f$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $9639c662cd69943f$var$uid = 0;
function $9639c662cd69943f$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$9639c662cd69943f$var$effectStack.includes(effect3)) {
            $9639c662cd69943f$var$cleanup(effect3);
            try {
                $9639c662cd69943f$var$enableTracking();
                $9639c662cd69943f$var$effectStack.push(effect3);
                $9639c662cd69943f$var$activeEffect = effect3;
                return fn();
            } finally{
                $9639c662cd69943f$var$effectStack.pop();
                $9639c662cd69943f$var$resetTracking();
                $9639c662cd69943f$var$activeEffect = $9639c662cd69943f$var$effectStack[$9639c662cd69943f$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $9639c662cd69943f$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $9639c662cd69943f$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $9639c662cd69943f$var$shouldTrack = true;
var $9639c662cd69943f$var$trackStack = [];
function $9639c662cd69943f$var$pauseTracking() {
    $9639c662cd69943f$var$trackStack.push($9639c662cd69943f$var$shouldTrack);
    $9639c662cd69943f$var$shouldTrack = false;
}
function $9639c662cd69943f$var$enableTracking() {
    $9639c662cd69943f$var$trackStack.push($9639c662cd69943f$var$shouldTrack);
    $9639c662cd69943f$var$shouldTrack = true;
}
function $9639c662cd69943f$var$resetTracking() {
    const last = $9639c662cd69943f$var$trackStack.pop();
    $9639c662cd69943f$var$shouldTrack = last === void 0 ? true : last;
}
function $9639c662cd69943f$var$track(target, type, key) {
    if (!$9639c662cd69943f$var$shouldTrack || $9639c662cd69943f$var$activeEffect === void 0) return;
    let depsMap = $9639c662cd69943f$var$targetMap.get(target);
    if (!depsMap) $9639c662cd69943f$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($9639c662cd69943f$var$activeEffect)) {
        dep.add($9639c662cd69943f$var$activeEffect);
        $9639c662cd69943f$var$activeEffect.deps.push(dep);
        if ($9639c662cd69943f$var$activeEffect.options.onTrack) $9639c662cd69943f$var$activeEffect.options.onTrack({
            effect: $9639c662cd69943f$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $9639c662cd69943f$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $9639c662cd69943f$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $9639c662cd69943f$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $9639c662cd69943f$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$9639c662cd69943f$var$isArray(target)) {
                    add2(depsMap.get($9639c662cd69943f$var$ITERATE_KEY));
                    if ($9639c662cd69943f$var$isMap(target)) add2(depsMap.get($9639c662cd69943f$var$MAP_KEY_ITERATE_KEY));
                } else if ($9639c662cd69943f$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$9639c662cd69943f$var$isArray(target)) {
                    add2(depsMap.get($9639c662cd69943f$var$ITERATE_KEY));
                    if ($9639c662cd69943f$var$isMap(target)) add2(depsMap.get($9639c662cd69943f$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($9639c662cd69943f$var$isMap(target)) add2(depsMap.get($9639c662cd69943f$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $9639c662cd69943f$var$isNonTrackableKeys = /* @__PURE__ */ $9639c662cd69943f$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $9639c662cd69943f$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($9639c662cd69943f$var$isSymbol));
var $9639c662cd69943f$var$get2 = /* @__PURE__ */ $9639c662cd69943f$var$createGetter();
var $9639c662cd69943f$var$readonlyGet = /* @__PURE__ */ $9639c662cd69943f$var$createGetter(true);
var $9639c662cd69943f$var$arrayInstrumentations = /* @__PURE__ */ $9639c662cd69943f$var$createArrayInstrumentations();
function $9639c662cd69943f$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $9639c662cd69943f$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$9639c662cd69943f$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($9639c662cd69943f$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $9639c662cd69943f$var$pauseTracking();
            const res = $9639c662cd69943f$var$toRaw(this)[key].apply(this, args);
            $9639c662cd69943f$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $9639c662cd69943f$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $9639c662cd69943f$var$shallowReadonlyMap : $9639c662cd69943f$var$readonlyMap : shallow ? $9639c662cd69943f$var$shallowReactiveMap : $9639c662cd69943f$var$reactiveMap).get(target)) return target;
        const targetIsArray = $9639c662cd69943f$var$isArray(target);
        if (!isReadonly && targetIsArray && $9639c662cd69943f$var$hasOwn($9639c662cd69943f$var$arrayInstrumentations, key)) return Reflect.get($9639c662cd69943f$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($9639c662cd69943f$var$isSymbol(key) ? $9639c662cd69943f$var$builtInSymbols.has(key) : $9639c662cd69943f$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $9639c662cd69943f$var$track(target, "get", key);
        if (shallow) return res;
        if ($9639c662cd69943f$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$9639c662cd69943f$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($9639c662cd69943f$var$isObject(res)) return isReadonly ? $9639c662cd69943f$var$readonly(res) : $9639c662cd69943f$var$reactive2(res);
        return res;
    };
}
var $9639c662cd69943f$var$set2 = /* @__PURE__ */ $9639c662cd69943f$var$createSetter();
function $9639c662cd69943f$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $9639c662cd69943f$var$toRaw(value);
            oldValue = $9639c662cd69943f$var$toRaw(oldValue);
            if (!$9639c662cd69943f$var$isArray(target) && $9639c662cd69943f$var$isRef(oldValue) && !$9639c662cd69943f$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $9639c662cd69943f$var$isArray(target) && $9639c662cd69943f$var$isIntegerKey(key) ? Number(key) < target.length : $9639c662cd69943f$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $9639c662cd69943f$var$toRaw(receiver)) {
            if (!hadKey) $9639c662cd69943f$var$trigger(target, "add", key, value);
            else if ($9639c662cd69943f$var$hasChanged(value, oldValue)) $9639c662cd69943f$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $9639c662cd69943f$var$deleteProperty(target, key) {
    const hadKey = $9639c662cd69943f$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $9639c662cd69943f$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $9639c662cd69943f$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$9639c662cd69943f$var$isSymbol(key) || !$9639c662cd69943f$var$builtInSymbols.has(key)) $9639c662cd69943f$var$track(target, "has", key);
    return result;
}
function $9639c662cd69943f$var$ownKeys(target) {
    $9639c662cd69943f$var$track(target, "iterate", $9639c662cd69943f$var$isArray(target) ? "length" : $9639c662cd69943f$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $9639c662cd69943f$var$mutableHandlers = {
    get: $9639c662cd69943f$var$get2,
    set: $9639c662cd69943f$var$set2,
    deleteProperty: $9639c662cd69943f$var$deleteProperty,
    has: $9639c662cd69943f$var$has,
    ownKeys: $9639c662cd69943f$var$ownKeys
};
var $9639c662cd69943f$var$readonlyHandlers = {
    get: $9639c662cd69943f$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $9639c662cd69943f$var$toReactive = (value)=>$9639c662cd69943f$var$isObject(value) ? $9639c662cd69943f$var$reactive2(value) : value;
var $9639c662cd69943f$var$toReadonly = (value)=>$9639c662cd69943f$var$isObject(value) ? $9639c662cd69943f$var$readonly(value) : value;
var $9639c662cd69943f$var$toShallow = (value)=>value;
var $9639c662cd69943f$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $9639c662cd69943f$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $9639c662cd69943f$var$toRaw(target);
    const rawKey = $9639c662cd69943f$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $9639c662cd69943f$var$track(rawTarget, "get", key);
    !isReadonly && $9639c662cd69943f$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $9639c662cd69943f$var$getProto(rawTarget);
    const wrap = isShallow ? $9639c662cd69943f$var$toShallow : isReadonly ? $9639c662cd69943f$var$toReadonly : $9639c662cd69943f$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $9639c662cd69943f$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $9639c662cd69943f$var$toRaw(target);
    const rawKey = $9639c662cd69943f$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $9639c662cd69943f$var$track(rawTarget, "has", key);
    !isReadonly && $9639c662cd69943f$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $9639c662cd69943f$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $9639c662cd69943f$var$track($9639c662cd69943f$var$toRaw(target), "iterate", $9639c662cd69943f$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $9639c662cd69943f$var$add(value) {
    value = $9639c662cd69943f$var$toRaw(value);
    const target = $9639c662cd69943f$var$toRaw(this);
    const proto = $9639c662cd69943f$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $9639c662cd69943f$var$trigger(target, "add", value, value);
    }
    return this;
}
function $9639c662cd69943f$var$set$1(key, value) {
    value = $9639c662cd69943f$var$toRaw(value);
    const target = $9639c662cd69943f$var$toRaw(this);
    const { has: has2, get: get3 } = $9639c662cd69943f$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $9639c662cd69943f$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $9639c662cd69943f$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $9639c662cd69943f$var$trigger(target, "add", key, value);
    else if ($9639c662cd69943f$var$hasChanged(value, oldValue)) $9639c662cd69943f$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $9639c662cd69943f$var$deleteEntry(key) {
    const target = $9639c662cd69943f$var$toRaw(this);
    const { has: has2, get: get3 } = $9639c662cd69943f$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $9639c662cd69943f$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $9639c662cd69943f$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $9639c662cd69943f$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $9639c662cd69943f$var$clear() {
    const target = $9639c662cd69943f$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $9639c662cd69943f$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $9639c662cd69943f$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $9639c662cd69943f$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $9639c662cd69943f$var$toRaw(target);
        const wrap = isShallow ? $9639c662cd69943f$var$toShallow : isReadonly ? $9639c662cd69943f$var$toReadonly : $9639c662cd69943f$var$toReactive;
        !isReadonly && $9639c662cd69943f$var$track(rawTarget, "iterate", $9639c662cd69943f$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $9639c662cd69943f$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $9639c662cd69943f$var$toRaw(target);
        const targetIsMap = $9639c662cd69943f$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $9639c662cd69943f$var$toShallow : isReadonly ? $9639c662cd69943f$var$toReadonly : $9639c662cd69943f$var$toReactive;
        !isReadonly && $9639c662cd69943f$var$track(rawTarget, "iterate", isKeyOnly ? $9639c662cd69943f$var$MAP_KEY_ITERATE_KEY : $9639c662cd69943f$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $9639c662cd69943f$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$9639c662cd69943f$var$capitalize(type)} operation ${key}failed: target is readonly.`, $9639c662cd69943f$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $9639c662cd69943f$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $9639c662cd69943f$var$get$1(this, key);
        },
        get size () {
            return $9639c662cd69943f$var$size(this);
        },
        has: $9639c662cd69943f$var$has$1,
        add: $9639c662cd69943f$var$add,
        set: $9639c662cd69943f$var$set$1,
        delete: $9639c662cd69943f$var$deleteEntry,
        clear: $9639c662cd69943f$var$clear,
        forEach: $9639c662cd69943f$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $9639c662cd69943f$var$get$1(this, key, false, true);
        },
        get size () {
            return $9639c662cd69943f$var$size(this);
        },
        has: $9639c662cd69943f$var$has$1,
        add: $9639c662cd69943f$var$add,
        set: $9639c662cd69943f$var$set$1,
        delete: $9639c662cd69943f$var$deleteEntry,
        clear: $9639c662cd69943f$var$clear,
        forEach: $9639c662cd69943f$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $9639c662cd69943f$var$get$1(this, key, true);
        },
        get size () {
            return $9639c662cd69943f$var$size(this, true);
        },
        has (key) {
            return $9639c662cd69943f$var$has$1.call(this, key, true);
        },
        add: $9639c662cd69943f$var$createReadonlyMethod("add"),
        set: $9639c662cd69943f$var$createReadonlyMethod("set"),
        delete: $9639c662cd69943f$var$createReadonlyMethod("delete"),
        clear: $9639c662cd69943f$var$createReadonlyMethod("clear"),
        forEach: $9639c662cd69943f$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $9639c662cd69943f$var$get$1(this, key, true, true);
        },
        get size () {
            return $9639c662cd69943f$var$size(this, true);
        },
        has (key) {
            return $9639c662cd69943f$var$has$1.call(this, key, true);
        },
        add: $9639c662cd69943f$var$createReadonlyMethod("add"),
        set: $9639c662cd69943f$var$createReadonlyMethod("set"),
        delete: $9639c662cd69943f$var$createReadonlyMethod("delete"),
        clear: $9639c662cd69943f$var$createReadonlyMethod("clear"),
        forEach: $9639c662cd69943f$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $9639c662cd69943f$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $9639c662cd69943f$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $9639c662cd69943f$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $9639c662cd69943f$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$9639c662cd69943f$var$mutableInstrumentations, $9639c662cd69943f$var$readonlyInstrumentations, $9639c662cd69943f$var$shallowInstrumentations, $9639c662cd69943f$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $9639c662cd69943f$var$createInstrumentations();
function $9639c662cd69943f$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $9639c662cd69943f$var$shallowReadonlyInstrumentations : $9639c662cd69943f$var$shallowInstrumentations : isReadonly ? $9639c662cd69943f$var$readonlyInstrumentations : $9639c662cd69943f$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($9639c662cd69943f$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $9639c662cd69943f$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $9639c662cd69943f$var$createInstrumentationGetter(false, false)
};
var $9639c662cd69943f$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $9639c662cd69943f$var$createInstrumentationGetter(true, false)
};
function $9639c662cd69943f$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $9639c662cd69943f$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $9639c662cd69943f$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $9639c662cd69943f$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $9639c662cd69943f$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $9639c662cd69943f$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $9639c662cd69943f$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $9639c662cd69943f$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $9639c662cd69943f$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $9639c662cd69943f$var$targetTypeMap($9639c662cd69943f$var$toRawType(value));
}
function $9639c662cd69943f$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $9639c662cd69943f$var$createReactiveObject(target, false, $9639c662cd69943f$var$mutableHandlers, $9639c662cd69943f$var$mutableCollectionHandlers, $9639c662cd69943f$var$reactiveMap);
}
function $9639c662cd69943f$var$readonly(target) {
    return $9639c662cd69943f$var$createReactiveObject(target, true, $9639c662cd69943f$var$readonlyHandlers, $9639c662cd69943f$var$readonlyCollectionHandlers, $9639c662cd69943f$var$readonlyMap);
}
function $9639c662cd69943f$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$9639c662cd69943f$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $9639c662cd69943f$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $9639c662cd69943f$var$toRaw(observed) {
    return observed && $9639c662cd69943f$var$toRaw(observed["__v_raw"]) || observed;
}
function $9639c662cd69943f$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$9639c662cd69943f$var$magic("nextTick", ()=>$9639c662cd69943f$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$9639c662cd69943f$var$magic("dispatch", (el)=>$9639c662cd69943f$var$dispatch.bind($9639c662cd69943f$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$9639c662cd69943f$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $9639c662cd69943f$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$9639c662cd69943f$var$magic("store", $9639c662cd69943f$var$getStores);
// packages/alpinejs/src/magics/$data.js
$9639c662cd69943f$var$magic("data", (el)=>$9639c662cd69943f$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$9639c662cd69943f$var$magic("root", (el)=>$9639c662cd69943f$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$9639c662cd69943f$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $9639c662cd69943f$var$mergeProxies($9639c662cd69943f$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $9639c662cd69943f$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $9639c662cd69943f$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $9639c662cd69943f$var$globalIdMemo = {};
function $9639c662cd69943f$var$findAndIncrementId(name) {
    if (!$9639c662cd69943f$var$globalIdMemo[name]) $9639c662cd69943f$var$globalIdMemo[name] = 0;
    return ++$9639c662cd69943f$var$globalIdMemo[name];
}
function $9639c662cd69943f$var$closestIdRoot(el, name) {
    return $9639c662cd69943f$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $9639c662cd69943f$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $9639c662cd69943f$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$9639c662cd69943f$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $9639c662cd69943f$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $9639c662cd69943f$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $9639c662cd69943f$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$9639c662cd69943f$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $9639c662cd69943f$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$9639c662cd69943f$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$9639c662cd69943f$var$warnMissingPluginMagic("Focus", "focus", "focus");
$9639c662cd69943f$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $9639c662cd69943f$var$warnMissingPluginMagic(name, magicName, slug) {
    $9639c662cd69943f$var$magic(magicName, (el)=>$9639c662cd69943f$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$9639c662cd69943f$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $9639c662cd69943f$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$9639c662cd69943f$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $9639c662cd69943f$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $9639c662cd69943f$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $9639c662cd69943f$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $9639c662cd69943f$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $9639c662cd69943f$var$skipDuringClone(()=>{
            $9639c662cd69943f$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $9639c662cd69943f$var$getTarget(expression);
        $9639c662cd69943f$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$9639c662cd69943f$var$mutateDom(()=>{
            clone2.remove();
            $9639c662cd69943f$var$destroyTree(clone2);
        }));
});
var $9639c662cd69943f$var$teleportContainerDuringClone = document.createElement("div");
function $9639c662cd69943f$var$getTarget(expression) {
    let target = $9639c662cd69943f$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $9639c662cd69943f$var$teleportContainerDuringClone;
    })();
    if (!target) $9639c662cd69943f$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $9639c662cd69943f$var$handler = ()=>{};
$9639c662cd69943f$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$9639c662cd69943f$var$directive("ignore", $9639c662cd69943f$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$9639c662cd69943f$var$directive("effect", $9639c662cd69943f$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($9639c662cd69943f$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $9639c662cd69943f$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $9639c662cd69943f$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $9639c662cd69943f$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $9639c662cd69943f$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $9639c662cd69943f$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $9639c662cd69943f$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $9639c662cd69943f$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($9639c662cd69943f$var$isKeyEvent(event) || $9639c662cd69943f$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($9639c662cd69943f$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $9639c662cd69943f$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $9639c662cd69943f$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $9639c662cd69943f$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $9639c662cd69943f$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $9639c662cd69943f$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $9639c662cd69943f$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $9639c662cd69943f$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $9639c662cd69943f$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $9639c662cd69943f$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $9639c662cd69943f$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($9639c662cd69943f$var$isClickEvent(e.type)) return false;
            if ($9639c662cd69943f$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $9639c662cd69943f$var$keyToModifiers(key) {
    if (!key) return [];
    key = $9639c662cd69943f$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$9639c662cd69943f$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $9639c662cd69943f$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $9639c662cd69943f$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $9639c662cd69943f$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $9639c662cd69943f$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($9639c662cd69943f$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $9639c662cd69943f$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($9639c662cd69943f$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($9639c662cd69943f$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($9639c662cd69943f$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($9639c662cd69943f$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($9639c662cd69943f$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $9639c662cd69943f$var$on(el, event, modifiers, (e)=>{
            setValue($9639c662cd69943f$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $9639c662cd69943f$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($9639c662cd69943f$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $9639c662cd69943f$var$on(el.form, "reset", [], (e)=>{
            $9639c662cd69943f$var$nextTick(()=>el._x_model && el._x_model.set($9639c662cd69943f$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $9639c662cd69943f$var$mutateDom(()=>$9639c662cd69943f$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $9639c662cd69943f$var$getInputValue(el, modifiers, event, currentValue) {
    return $9639c662cd69943f$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($9639c662cd69943f$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $9639c662cd69943f$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $9639c662cd69943f$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$9639c662cd69943f$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $9639c662cd69943f$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $9639c662cd69943f$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($9639c662cd69943f$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $9639c662cd69943f$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $9639c662cd69943f$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $9639c662cd69943f$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $9639c662cd69943f$var$isNumeric2(number) ? number : rawValue;
}
function $9639c662cd69943f$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $9639c662cd69943f$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $9639c662cd69943f$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$9639c662cd69943f$var$directive("cloak", (el)=>queueMicrotask(()=>$9639c662cd69943f$var$mutateDom(()=>el.removeAttribute($9639c662cd69943f$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$9639c662cd69943f$var$addInitSelector(()=>`[${$9639c662cd69943f$var$prefix("init")}]`);
$9639c662cd69943f$var$directive("init", $9639c662cd69943f$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$9639c662cd69943f$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $9639c662cd69943f$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$9639c662cd69943f$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $9639c662cd69943f$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $9639c662cd69943f$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$9639c662cd69943f$var$mapAttributes($9639c662cd69943f$var$startingWith(":", $9639c662cd69943f$var$into($9639c662cd69943f$var$prefix("bind:"))));
var $9639c662cd69943f$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $9639c662cd69943f$var$injectBindingProviders(bindingProviders);
        let getBindings = $9639c662cd69943f$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $9639c662cd69943f$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $9639c662cd69943f$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $9639c662cd69943f$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $9639c662cd69943f$var$mutateDom(()=>$9639c662cd69943f$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$9639c662cd69943f$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$9639c662cd69943f$var$directive("bind", $9639c662cd69943f$var$handler2);
function $9639c662cd69943f$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$9639c662cd69943f$var$addRootSelector(()=>`[${$9639c662cd69943f$var$prefix("data")}]`);
$9639c662cd69943f$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($9639c662cd69943f$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $9639c662cd69943f$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $9639c662cd69943f$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $9639c662cd69943f$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $9639c662cd69943f$var$injectMagics(data2, el);
    let reactiveData = $9639c662cd69943f$var$reactive(data2);
    $9639c662cd69943f$var$initInterceptors(reactiveData);
    let undo = $9639c662cd69943f$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $9639c662cd69943f$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $9639c662cd69943f$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$9639c662cd69943f$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $9639c662cd69943f$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$9639c662cd69943f$var$isCloning) return false;
    if ($9639c662cd69943f$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$9639c662cd69943f$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $9639c662cd69943f$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $9639c662cd69943f$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $9639c662cd69943f$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $9639c662cd69943f$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$9639c662cd69943f$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $9639c662cd69943f$var$parseForExpression(expression);
    let evaluateItems = $9639c662cd69943f$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $9639c662cd69943f$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$9639c662cd69943f$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$9639c662cd69943f$var$mutateDom(()=>{
                $9639c662cd69943f$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $9639c662cd69943f$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($9639c662cd69943f$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $9639c662cd69943f$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $9639c662cd69943f$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $9639c662cd69943f$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $9639c662cd69943f$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $9639c662cd69943f$var$mutateDom(()=>{
                $9639c662cd69943f$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $9639c662cd69943f$var$mutateDom(()=>{
                if (!elForSpot) $9639c662cd69943f$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $9639c662cd69943f$var$reactive(scope2);
            $9639c662cd69943f$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $9639c662cd69943f$var$mutateDom(()=>{
                lastEl.after(clone2);
                $9639c662cd69943f$var$skipDuringClone(()=>$9639c662cd69943f$var$initTree(clone2))();
            });
            if (typeof key === "object") $9639c662cd69943f$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $9639c662cd69943f$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $9639c662cd69943f$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $9639c662cd69943f$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $9639c662cd69943f$var$handler3() {}
$9639c662cd69943f$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $9639c662cd69943f$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$9639c662cd69943f$var$directive("ref", $9639c662cd69943f$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$9639c662cd69943f$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $9639c662cd69943f$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $9639c662cd69943f$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $9639c662cd69943f$var$addScopeToNode(clone2, {}, el);
        $9639c662cd69943f$var$mutateDom(()=>{
            el.after(clone2);
            $9639c662cd69943f$var$skipDuringClone(()=>$9639c662cd69943f$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $9639c662cd69943f$var$mutateDom(()=>{
                $9639c662cd69943f$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$9639c662cd69943f$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$9639c662cd69943f$var$setIdRoot(el, name));
});
$9639c662cd69943f$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$9639c662cd69943f$var$mapAttributes($9639c662cd69943f$var$startingWith("@", $9639c662cd69943f$var$into($9639c662cd69943f$var$prefix("on:"))));
$9639c662cd69943f$var$directive("on", $9639c662cd69943f$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $9639c662cd69943f$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $9639c662cd69943f$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$9639c662cd69943f$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$9639c662cd69943f$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$9639c662cd69943f$var$warnMissingPluginDirective("Focus", "trap", "focus");
$9639c662cd69943f$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $9639c662cd69943f$var$warnMissingPluginDirective(name, directiveName, slug) {
    $9639c662cd69943f$var$directive(directiveName, (el)=>$9639c662cd69943f$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$9639c662cd69943f$var$alpine_default.setEvaluator($9639c662cd69943f$var$normalEvaluator);
$9639c662cd69943f$var$alpine_default.setRawEvaluator($9639c662cd69943f$var$normalRawEvaluator);
$9639c662cd69943f$var$alpine_default.setReactivityEngine({
    reactive: $9639c662cd69943f$var$reactive2,
    effect: $9639c662cd69943f$var$effect2,
    release: $9639c662cd69943f$var$stop,
    raw: $9639c662cd69943f$var$toRaw
});
var $9639c662cd69943f$export$b7ee041e4ad2afec = $9639c662cd69943f$var$alpine_default;
// packages/alpinejs/builds/module.js
var $9639c662cd69943f$export$2e2bcd8739ae039 = $9639c662cd69943f$export$b7ee041e4ad2afec;


const $3ac1be129fe8280c$var$apiUrl = "https://monsters.of.rodeo/api/concerts" ?? '';
const $3ac1be129fe8280c$var$fetchConcerts = async ()=>{
    try {
        const response = await fetch($3ac1be129fe8280c$var$apiUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        return await response.json();
    } catch  {
        return [
            {
                title: 'Fehler 500: Crisis on Infinite Earths',
                dateStart: '3048-11-13',
                link: 'https://de.wikipedia.org/wiki/Crisis_on_Infinite_Earths',
                bands: [
                    {
                        name: "Die aktuellen Daten konnten leider nicht abgerufen werden, bitte versuche es sp\xe4ter noch einmal."
                    }
                ]
            }
        ];
    }
};
window.Alpine = (0, $9639c662cd69943f$export$2e2bcd8739ae039);
(0, $9639c662cd69943f$export$2e2bcd8739ae039).data('concerts', ()=>({
        concerts: [],
        dateBeforeNow (date) {
            return Date.parse(date) < Date.now();
        },
        getDateDay (date) {
            const jsDate = new Date(date);
            return jsDate.getDate();
        },
        getDateMonth (date) {
            const jsDate = new Date(date);
            return jsDate.toLocaleDateString('de-DE', {
                month: 'long'
            });
        },
        getDateYear (date) {
            const jsDate = new Date(date);
            return jsDate.getFullYear();
        },
        async getData () {
            this.concerts = await $3ac1be129fe8280c$var$fetchConcerts();
        }
    }));
(0, $9639c662cd69943f$export$2e2bcd8739ae039).start();
const $3ac1be129fe8280c$var$bodyEl = document.body;
$3ac1be129fe8280c$var$bodyEl.classList.remove('no-js');
window.addEventListener('load', ()=>{
    setTimeout(()=>{
        $3ac1be129fe8280c$var$bodyEl.classList.add('initialized');
    }, 500);
});
const $3ac1be129fe8280c$var$toggleConcerts = (trigger)=>{
    const hiddenConcerts = document.querySelectorAll('.concert--hidden');
    hiddenConcerts.forEach((element)=>{
        element.classList.remove('concert--hidden');
    });
    trigger.remove();
};
window.toggleConcerts = $3ac1be129fe8280c$var$toggleConcerts;


//# sourceMappingURL=web-frontend-monsters.9870359b.js.map
